import type { MessageDescriptor } from 'react-intl';

import messages from './messages';

export const getLoadingTitle = (
	title: string | undefined,
	formatMessage: (descriptor: MessageDescriptor) => string,
): string => {
	if (!title) {
		return formatMessage(messages.loadingEditingTitle);
	}

	if (title.includes('Translate')) {
		return formatMessage(messages.loadingTranslating);
	}

	if (title.includes('Change tone')) {
		return formatMessage(messages.loadingChangingTone);
	}

	switch (title) {
		case 'Make shorter':
			return formatMessage(messages.loadingShortening);
		case 'Make longer':
			return formatMessage(messages.loadingLengthening);
		case 'Fix spelling & grammar':
			return formatMessage(messages.loadingFixingSpellingAndGrammar);
		case 'Add polish':
			return formatMessage(messages.loadingPolishing);
		case 'Summarize':
			return formatMessage(messages.loadingSummarizing);
		default:
			return formatMessage(messages.loadingEditingTitle);
	}
};
